import {combineReducers} from "redux";
import sportGameReducer from "../../sport/redux/sportGameReducer";
import horseGameReducer from "../../horse/redux/horseGameReducer";
import type {GameReducerState} from "./gameTypes";

export default combineReducers<GameReducerState>({
    horse: horseGameReducer,
    sport: sportGameReducer,
});
